import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { APIService } from '../../api.service';
import { DataService } from '../../services/data.service'

@Component({
  selector: 'app-jobcard-print',
  templateUrl: './jobcard-print.component.html',
  styleUrls: ['./jobcard-print.component.scss']
})
export class JobcardPrintComponent implements OnInit {
  jobID: number = 0;
  itemID: number = 0;
  jarvisData: Array<any> = [];
  MTbl: Array<any> = [];
  jobDetails: any = [];
  productItems:Array<any> = [];
  getAllItems:Array<any> = [];
  moveStages: Array<any> = [];
  Name: any;
  JTBL: any;
  UserID: any;
  jobCardDetails:  any = [];
  jobTypeID: number = 1;
  prjStages: Array<any> = [];
  users: Array<any> = [];
  prtCfg: { jobInst: boolean, itemDesc: boolean }  = {
    jobInst: false,
    itemDesc: false
  };

  constructor(private commonFunService: CommonService, private apiService: APIService,private dataSer: DataService) {}

  ngOnInit(): void {
    this.jobID = Number(this.commonFunService.GetParam("JobID"));
    this.itemID = Number(this.commonFunService.GetParam("IID"));
    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    var tblM = this.apiService.getCookie('M');
    if (tblM) {
      this.MTbl = JSON.parse(tblM);
    }

    let tempUsers = this.apiService.getCookie("J");
    if (tempUsers) {
      this.users = JSON.parse(tempUsers)
    }

    this.getJobDetails();
    
  }


  printJobCardData() {
    setTimeout(function () {
        var printArea = $('#JobCardPrint').html();
        $('body').html(printArea);
        window.print();
    });
  }

  getJobDetails() {
    let obj = [
      {
        JobID: this.jobID,
      },
    ];

    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.MTbl[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getPrdJobDetails',
        moduleID: 8,
        data: JSON.stringify(obj),
      },
    ];

    this.apiService.getData(
      myParams,
      this.successJobDetails.bind(this),
      this.failureResp.bind(this)
    );
  }

  successJobDetails(res: any) {  
    if (res.error) {
    }
     else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        console.log("Job Data", reponseData);
        let relID = 0
        if (reponseData) {
          if(reponseData.Table1.length > 0){
            // Get Job's Data
            this.jobDetails = reponseData.Table1[0];
            relID = this.jobDetails.CstrRelativeID ? this.jobDetails.CstrRelativeID : 0
            this.jobTypeID = this.jobDetails.JobTypeID ? this.jobDetails.JobTypeID : 1
            if(this.jobDetails.PrtCfg) {
              let prtCnfg = JSON.parse(this.jobDetails.PrtCfg);
              if(prtCnfg && prtCnfg.length > 0) {
                this.prtCfg.jobInst = prtCnfg[0].jobInst ? prtCnfg[0].jobInst : false;
                this.prtCfg.itemDesc = prtCnfg[0].itemDesc ? prtCnfg[0].itemDesc : false;
              }
            }
            // Get JobCard Details
            this.jobCardDetails = reponseData.Table2
           
            // this.jobCardDetails.forEach((x: any) => {
            //   x.PlanQty = x.PlanQty + " " + x.SKU,
            //   x.UsedQty = x.UsedQty + " " + x.SKU
            // })                    

            let tblJ: any = this.apiService.getCookie("J");
            if(tblJ) {
              tblJ = JSON.parse(tblJ);
            }
            // Get Product Details
            this.productItems = reponseData.Table3;

            //Get JobCard Data
            // jobCardData.forEach((x: any) => {
            //   let selectedItem = this.productItems.filter((o: any) => o.PlanQty == x.PQty)
            //   this.jobCardDetails.push({
            //   itemName : selectedItem[0].ItemName,
            //   itemCode : selectedItem[0].ItemCode,
            //   planQty: x.PQty,
            //   usedQty: x.UQty
            //   })
            // })
            
          // Get Jobs History (Get Movement data from Jobs histoty array)
            let stageHistory: any = reponseData.Table1[0].History;
            var stagesArry :Array<any> = [];
            if(stageHistory){
              stagesArry = JSON.parse(stageHistory)
              stagesArry = stagesArry.filter((o: any) => o.Typ == 'MVM');

              // Get All job Stages
              let stages: any = reponseData.Table1[0].Stages;
              if(stages){
                stages = JSON.parse(stages);
              }
              
              // Prepare array for Movement Stage
              // jobCardData.forEach((x: any) => {
              //   let getJobData = this.jobCardDetails.filter((o: any) => {o.ItemName && o.ItemCode});
              //   this.jobCardDetails 
              // });
              
              // Prepare array for Movement Stage
              stagesArry.forEach((x: any) => {
                let selectedPrd = this.productItems.filter((o: any) => o.PID == this.itemID);
                let selectedUser = tblJ.filter((o: any) => o.UserID == x.By);

                let userName = "";
                if(selectedUser.length > 0){
                  userName = selectedUser[0].Name
                }

                let stageRejections = x.Rejns;
                if(stageRejections){
                  stageRejections = JSON.parse(stageRejections)
                }
                else{
                  stageRejections = [];
                }

                let opngQty: number = 0;
                let doneQty: number = 0;
                let rejQty: number = 0;

                for(let i = 0; i < stageRejections.length; i++) {
                  rejQty = rejQty + Number(stageRejections[i].RQty ? stageRejections[i].RQty : 0);
                }

                if(this.moveStages.length == 0){
                  opngQty = selectedPrd[0]?.PlanQty ? selectedPrd[0]?.PlanQty : 0;
                  doneQty = (selectedPrd[0]?.PlanQty ? selectedPrd[0]?.PlanQty : 0) - rejQty;
                }
                else{
                  opngQty = this.moveStages[this.moveStages.length - 1].doneQty;
                  doneQty = opngQty - rejQty;
                }
                
                // Create final Stage array for print
                if(x.TStgID > 0){
                  this.moveStages.push({
                    stageName: stages.filter((o: any) => o.SID == x.TStgID)[0].SNm,
                    opngQty: opngQty,
                    doneQty: doneQty,
                    rejQty: rejQty,
                    unit: selectedPrd[0].SKU,
                    doneOn: x.On,
                    doneBy: userName,
                    note: x.Notes
                  });
                }
              });

              if (this.jobTypeID == 2 && stages && stages.length > 0){
                const stage = stages[0];
                if (stage && ('IN' in stage || 'CN' in stage)) {
                  this.prjStages = stages;

                  this.prjStages.forEach((stage: any) => {
                    stage.startDT = stage.SDT ? (new Date(stage.SDT).customFormat("#DD#-#MMM#-#YY#")) : '-'; 
                    stage.targetDT = stage.TDT ? (new Date(stage.TDT).customFormat("#DD#-#MMM#-#YY#")) : '-';
                    stage.endDT = stage.EDT ? (new Date(stage.EDT).customFormat("#DD#-#MMM#-#YY#")) : '-'; 
                    
                    let startByUID = stage.SUID ? stage.SUID : 0;
                    let tempUsers = this.users.filter((x: any) => x.UserID == startByUID);
                    stage.by = tempUsers.length > 0 ? tempUsers[0].Name : '-';
                  });

                  this.prjStages.sort((a: any, b: any) => a.Seq - b.Seq);
                }
              }
            }
          }
        }
        this.printJobCardData();
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
      //alert(this.title + ' done!');
    }
  }
}

